import script from "./ManageContentDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageContentDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ManageContentDrawer.vue?vue&type=style&index=0&id=2f850374&lang=scss"

const __exports__ = script;

export default __exports__